import React from 'react';
import './BookDetail.css';

const BookDetail = ({ book, onBack, onBorrow }) => {
  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleDateString('zh-HK');
  };

  const getStatusText = (book) => {
    switch (book.status) {
      case 'available':
        return '可借';
      case 'borrowed':
        return '已借出';
      case 'overdue':
        return '逾期';
      case 'reserved':
        return '已預約';
      case 'maintenance':
        return '維護中';
      default:
        return '未知';
    }
  };

  const getStatusClass = (book) => {
    switch (book.status) {
      case 'available':
        return 'status-available';
      case 'borrowed':
        return 'status-borrowed';
      case 'overdue':
        return 'status-overdue';
      case 'reserved':
        return 'status-reserved';
      case 'maintenance':
        return 'status-maintenance';
      default:
        return 'status-unknown';
    }
  };

  const canBorrow = book.status === 'available';

  return (
    <div className="book-detail">
      <div className="book-detail-header">
        <button className="back-button" onClick={onBack}>
          ← 返回目錄
        </button>
        <h2>圖書詳情</h2>
      </div>

      <div className="book-detail-content">
        <div className="book-main-info">
          <div className="book-cover-section">
            {book.coverUrl ? (
              <img src={book.coverUrl} alt={book.title} className="book-cover" />
            ) : (
              <div className="book-cover-placeholder">
                <span className="cover-text">📚</span>
                <span className="cover-title">{book.title}</span>
              </div>
            )}
            <div className="book-status">
              <span className={`status-badge ${getStatusClass(book)}`}>
                {getStatusText(book)}
              </span>
            </div>
          </div>

          <div className="book-info-section">
            <h1 className="book-title">{book.title}</h1>
            {book.titleEn && (
              <h2 className="book-title-en">{book.titleEn}</h2>
            )}

            <div className="book-meta">
              <div className="meta-item">
                <span className="meta-label">索書號:</span>
                <span className="meta-value">{book.call_number || book.callNumber || 'N/A'}</span>
              </div>
              <div className="meta-item">
                <span className="meta-label">作者:</span>
                <span className="meta-value">{book.author || 'N/A'}</span>
                {book.authorEn && (
                  <span className="meta-value-en">({book.authorEn})</span>
                )}
              </div>
              <div className="meta-item">
                <span className="meta-label">出版社:</span>
                <span className="meta-value">{book.publisher || 'N/A'}</span>
              </div>
              <div className="meta-item">
                <span className="meta-label">出版年份:</span>
                <span className="meta-value">{book.publication_year || book.publishYear || 'N/A'}</span>
              </div>
              <div className="meta-item">
                <span className="meta-label">ISBN:</span>
                <span className="meta-value">{book.isbn || 'N/A'}</span>
              </div>
            </div>

            <div className="book-description">
              <h3>內容簡介</h3>
              <p>{book.description || '暫無內容簡介'}</p>
            </div>

            <div className="book-actions">
              {canBorrow ? (
                <button className="borrow-button" onClick={onBorrow}>
                  借閱此書
                </button>
              ) : (
                <button className="reserve-button" disabled>
                  預約此書
                </button>
              )}
              <button className="share-button">
                分享
              </button>
            </div>
          </div>
        </div>

        <div className="book-details-grid">
          <div className="detail-section">
            <h3>基本資料</h3>
            <div className="detail-grid">
              <div className="detail-item">
                <span className="detail-label">頁數:</span>
                <span className="detail-value">{book.pages ? `${book.pages} 頁` : 'N/A'}</span>
              </div>
              <div className="detail-item">
                <span className="detail-label">語言:</span>
                <span className="detail-value">{book.language || 'N/A'}</span>
              </div>
              <div className="detail-item">
                <span className="detail-label">格式:</span>
                <span className="detail-value">{book.format || 'N/A'}</span>
              </div>
              <div className="detail-item">
                <span className="detail-label">分類:</span>
                <span className="detail-value">{book.category?.name || book.category || 'N/A'}</span>
              </div>
              <div className="detail-item">
                <span className="detail-label">主題:</span>
                <span className="detail-value">{book.subject || 'N/A'}</span>
              </div>
              <div className="detail-item">
                <span className="detail-label">位置:</span>
                <span className="detail-value">{book.location || 'N/A'}</span>
              </div>
            </div>
          </div>

          <div className="detail-section">
            <h3>標籤</h3>
            <div className="tags-container">
              {book.tags && book.tags.length > 0 ? (
                book.tags.map((tag, index) => (
                  <span key={index} className="tag">
                    {tag}
                  </span>
                ))
              ) : (
                <span className="no-tags">暫無標籤</span>
              )}
            </div>
          </div>

          <div className="detail-section">
            <h3>系統資料</h3>
            <div className="detail-grid">
              <div className="detail-item">
                <span className="detail-label">新增日期:</span>
                <span className="detail-value">{book.created_at ? formatDate(book.created_at) : 'N/A'}</span>
              </div>
              <div className="detail-item">
                <span className="detail-label">最後更新:</span>
                <span className="detail-value">{book.updated_at ? formatDate(book.updated_at) : 'N/A'}</span>
              </div>
              <div className="detail-item">
                <span className="detail-label">ACNO:</span>
                <span className="detail-value">{book.acno || 'N/A'}</span>
              </div>
            </div>
          </div>
        </div>

        <div className="book-related">
          <h3>相關圖書</h3>
          <p className="related-placeholder">
            基於此書的主題和作者，系統會推薦相關圖書。
          </p>
        </div>
      </div>
    </div>
  );
};

export default BookDetail;
